/**
 * @file AddBtn
 */

'use strict';

/**
 * @classname BtnDelete
 * @classdesc BtnDelete
 */
export default class BtnDelete {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log(`BtnDelete.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._$base = $e.closest($e.attr('data-base-object'));
		this._$e.on('click', () => this.onClick());
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof AddBtn
	 * @return {undefined}
	 */
	onClick() {
		console.log(`BtnDelete.onClick`);
		const $baseWrap = this._$base.parent();
		this._$base.remove();
		this._controller.reNumbering($baseWrap);
		if (!!$('.list-councils-to-contribute').length) this._controller.recalculateContributionPrice()
	};
}
